import { render, staticRenderFns } from "./PreviaDeImpressaoDeEtiqueta.vue?vue&type=template&id=7cc18ada&scoped=true&"
import script from "./PreviaDeImpressaoDeEtiqueta.vue?vue&type=script&lang=ts&"
export * from "./PreviaDeImpressaoDeEtiqueta.vue?vue&type=script&lang=ts&"
import style0 from "./PreviaDeImpressaoDeEtiqueta.vue?vue&type=style&index=0&id=7cc18ada&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc18ada",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VIcon})
